import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingService } from './services/loading.service';
import { IconService } from './services/icon.service';
import { CheckForUpdateService } from './services/check-for-update';
import { NetworkStatusService } from './services/network-status.service';
import { DomainRedirectService } from './services/domain-redirect.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AuthModule } from '@auth0/auth0-angular';
import { ServiceWorkerModule } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [CommonModule, RouterOutlet, TranslateModule, AuthModule, ServiceWorkerModule],
})
export class AppComponent implements OnInit {
  protected loadingService = inject(LoadingService);
  protected checkForUpdateService = inject(CheckForUpdateService);
  protected networkStatusService = inject(NetworkStatusService);
  protected domainRedirectService = inject(DomainRedirectService);

  // TODO: Move to custom icons via tailwind css
  // For now it is injected here so all components can use it
  public iconService = inject(IconService);

  loading$ = this.loadingService.loading$;
  title = 'nicky';

  ngOnInit() {
    this.domainRedirectService.checkAndRedirect();
  }
}
